var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-row",
        { attrs: { gutter: 24 } },
        [
          _c(
            "el-col",
            { attrs: { span: 24 } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "规格类型：", props: "specType" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      attrs: { disabled: _vm.isDisabled },
                      on: {
                        change: function ($event) {
                          return _vm.onChangeSpec(_vm.formValidate.specType)
                        },
                      },
                      model: {
                        value: _vm.formValidate.specType,
                        callback: function ($$v) {
                          _vm.$set(_vm.formValidate, "specType", $$v)
                        },
                        expression: "formValidate.specType",
                      },
                    },
                    [
                      _c(
                        "el-radio",
                        { staticClass: "radio", attrs: { label: false } },
                        [_vm._v("单规格")]
                      ),
                      _c("el-radio", { attrs: { label: true } }, [
                        _vm._v("多规格"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm.formValidate.specType && !_vm.isDisabled
            ? _c(
                "el-col",
                { staticClass: "noForm", attrs: { span: 24 } },
                [
                  _c("el-form-item", { attrs: { label: "商品规格：" } }, [
                    _c(
                      "div",
                      { staticClass: "specifications" },
                      [
                        _c(
                          "draggable",
                          {
                            attrs: {
                              group: "specifications",
                              list: _vm.formValidate.attrs,
                              handle: ".move-icon",
                              animation: "300",
                            },
                            on: { end: _vm.onMoveSpec },
                          },
                          _vm._l(
                            _vm.formValidate.attrs,
                            function (item, index) {
                              return _c(
                                "div",
                                {
                                  key: index,
                                  staticClass: "specifications-item active",
                                  on: {
                                    click: function ($event) {
                                      return _vm.changeCurrentIndex(index)
                                    },
                                  },
                                },
                                [
                                  _c("div", { staticClass: "move-icon" }, [
                                    _c("span", {
                                      staticClass: "iconfont icon-drag2",
                                    }),
                                  ]),
                                  _c("i", {
                                    staticClass: "del el-icon-error",
                                    on: {
                                      click: function ($event) {
                                        return _vm.handleRemoveRole(
                                          index,
                                          item.value
                                        )
                                      },
                                    },
                                  }),
                                  _c(
                                    "div",
                                    { staticClass: "specifications-item-box" },
                                    [
                                      _c("div", { staticClass: "lineBox" }),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "specifications-item-name mb18",
                                        },
                                        [
                                          _c("el-input", {
                                            staticClass:
                                              "specifications-item-name-input",
                                            attrs: {
                                              size: "small",
                                              placeholder: "规格名称",
                                            },
                                            on: {
                                              change: function ($event) {
                                                return _vm.attrChangeValue(
                                                  index,
                                                  item.value
                                                )
                                              },
                                              focus: function ($event) {
                                                return _vm.handleFocus(
                                                  item.value
                                                )
                                              },
                                            },
                                            model: {
                                              value: item.value,
                                              callback: function ($$v) {
                                                _vm.$set(item, "value", $$v)
                                              },
                                              expression: "item.value",
                                            },
                                          }),
                                          _c(
                                            "el-checkbox",
                                            {
                                              staticClass: "ml20",
                                              attrs: {
                                                disabled:
                                                  !item.add_pic && !_vm.canSel,
                                                "true-label": 1,
                                                "false-label": 0,
                                              },
                                              on: {
                                                change: function (e) {
                                                  return _vm.addPic(e, index)
                                                },
                                              },
                                              model: {
                                                value: item.add_pic,
                                                callback: function ($$v) {
                                                  _vm.$set(item, "add_pic", $$v)
                                                },
                                                expression: "item.add_pic",
                                              },
                                            },
                                            [_vm._v("添加规格图")]
                                          ),
                                          _c(
                                            "el-tooltip",
                                            {
                                              staticClass: "item",
                                              attrs: {
                                                effect: "dark",
                                                content:
                                                  "添加规格图片, 仅支持打开一个(建议尺寸:800*800)",
                                                placement: "right",
                                              },
                                            },
                                            [
                                              _c("i", {
                                                staticClass: "el-icon-info",
                                              }),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "div",
                                        { staticClass: "rulesBox ml30" },
                                        [
                                          _c(
                                            "draggable",
                                            {
                                              staticClass: "item",
                                              attrs: {
                                                list: item.detail,
                                                disabled:
                                                  item.detail.length < 2,
                                                handle: ".drag",
                                              },
                                              on: { end: _vm.onMoveSpec },
                                            },
                                            [
                                              _vm._l(
                                                item.detail,
                                                function (det, indexn) {
                                                  return _c(
                                                    "div",
                                                    {
                                                      key: indexn,
                                                      staticClass:
                                                        "mr10 spec drag",
                                                    },
                                                    [
                                                      _c("i", {
                                                        staticClass:
                                                          "el-icon-error",
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.handleRemove2(
                                                              item.detail,
                                                              indexn,
                                                              det.value
                                                            )
                                                          },
                                                        },
                                                      }),
                                                      _c(
                                                        "el-input",
                                                        {
                                                          staticStyle: {
                                                            width: "120px",
                                                          },
                                                          attrs: {
                                                            size: "small",
                                                            placeholder:
                                                              "规格值",
                                                          },
                                                          on: {
                                                            change: function (
                                                              $event
                                                            ) {
                                                              return _vm.attrDetailChangeValue(
                                                                det.value,
                                                                index
                                                              )
                                                            },
                                                            focus: function (
                                                              $event
                                                            ) {
                                                              return _vm.handleFocus(
                                                                det.value
                                                              )
                                                            },
                                                            blur: function (
                                                              $event
                                                            ) {
                                                              return _vm.handleBlur()
                                                            },
                                                          },
                                                          model: {
                                                            value: det.value,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                det,
                                                                "value",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "det.value",
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "template",
                                                            { slot: "prefix" },
                                                            [
                                                              _c("span", {
                                                                staticClass:
                                                                  "iconfont icon-drag2",
                                                              }),
                                                            ]
                                                          ),
                                                        ],
                                                        2
                                                      ),
                                                      item.add_pic
                                                        ? _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "img-popover",
                                                            },
                                                            [
                                                              _c("div", {
                                                                staticClass:
                                                                  "popper-arrow",
                                                              }),
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "popper",
                                                                  on: {
                                                                    click:
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        return _vm.handleSelImg(
                                                                          det,
                                                                          indexn
                                                                        )
                                                                      },
                                                                  },
                                                                },
                                                                [
                                                                  det.image
                                                                    ? _c(
                                                                        "img",
                                                                        {
                                                                          staticClass:
                                                                            "img",
                                                                          attrs:
                                                                            {
                                                                              src: det.image,
                                                                            },
                                                                        }
                                                                      )
                                                                    : _c("i", {
                                                                        staticClass:
                                                                          "el-icon-plus",
                                                                      }),
                                                                ]
                                                              ),
                                                              det.image
                                                                ? _c("i", {
                                                                    staticClass:
                                                                      "img-del el-icon-error",
                                                                    on: {
                                                                      click:
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          return _vm.handleRemoveImg(
                                                                            det
                                                                          )
                                                                        },
                                                                    },
                                                                  })
                                                                : _vm._e(),
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                    ],
                                                    1
                                                  )
                                                }
                                              ),
                                              _c(
                                                "el-popover",
                                                {
                                                  ref: "popoverRef_" + index,
                                                  refInFor: true,
                                                  attrs: {
                                                    placement: "",
                                                    width: "210",
                                                    trigger: "click",
                                                  },
                                                  on: {
                                                    "after-enter": function (
                                                      $event
                                                    ) {
                                                      return _vm.handleShowPop(
                                                        index
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _c("el-input", {
                                                    ref: "inputRef_" + index,
                                                    refInFor: true,
                                                    attrs: {
                                                      size: "small",
                                                      placeholder:
                                                        "请输入规格值",
                                                    },
                                                    on: {
                                                      blur: function ($event) {
                                                        return _vm.createAttr(
                                                          _vm.formDynamic
                                                            .attrsVal,
                                                          index
                                                        )
                                                      },
                                                    },
                                                    nativeOn: {
                                                      keyup: function ($event) {
                                                        if (
                                                          !$event.type.indexOf(
                                                            "key"
                                                          ) &&
                                                          _vm._k(
                                                            $event.keyCode,
                                                            "enter",
                                                            13,
                                                            $event.key,
                                                            "Enter"
                                                          )
                                                        ) {
                                                          return null
                                                        }
                                                        return _vm.createAttr(
                                                          _vm.formDynamic
                                                            .attrsVal,
                                                          index
                                                        )
                                                      },
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.formDynamic
                                                          .attrsVal,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.formDynamic,
                                                          "attrsVal",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "formDynamic.attrsVal",
                                                    },
                                                  }),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass: "addfont",
                                                      attrs: {
                                                        slot: "reference",
                                                      },
                                                      slot: "reference",
                                                    },
                                                    [_vm._v("添加规格值")]
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            2
                                          ),
                                        ],
                                        1
                                      ),
                                    ]
                                  ),
                                ]
                              )
                            }
                          ),
                          0
                        ),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "flex" },
                      [
                        _c("el-button", { on: { click: _vm.handleAddRole } }, [
                          _vm._v("添加新规格"),
                        ]),
                      ],
                      1
                    ),
                  ]),
                ],
                1
              )
            : _vm._e(),
          _c(
            "el-col",
            { attrs: { xl: 24, lg: 24, md: 24, sm: 24, xs: 24 } },
            [
              _vm.formValidate.specType === false
                ? _c(
                    "el-form-item",
                    [
                      _c("el-alert", {
                        attrs: {
                          title: "价格设置范围 0.01~999999.99",
                          type: "info",
                        },
                      }),
                      _c(
                        "el-table",
                        {
                          staticClass: "tabNumWidth",
                          attrs: {
                            data: _vm.OneattrValue,
                            border: "",
                            size: "small",
                          },
                        },
                        [
                          _c("el-table-column", {
                            attrs: {
                              label: "图片",
                              width: "77",
                              align: "center",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "upLoadPicBox",
                                          on: {
                                            click: function ($event) {
                                              return _vm.modalPicTap(
                                                false,
                                                "dan",
                                                "pi"
                                              )
                                            },
                                          },
                                        },
                                        [
                                          scope.row.image
                                            ? _c(
                                                "div",
                                                { staticClass: "tabPic" },
                                                [
                                                  _c("img", {
                                                    attrs: {
                                                      src: scope.row.image,
                                                    },
                                                  }),
                                                ]
                                              )
                                            : _c(
                                                "div",
                                                {
                                                  staticClass: "upLoad tabPic",
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass:
                                                      "el-icon-camera cameraIconfont",
                                                  }),
                                                ]
                                              ),
                                        ]
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              2080822489
                            ),
                          }),
                          _vm._l(_vm.tableAttrValue, function (item, iii) {
                            return _c("el-table-column", {
                              key: iii,
                              attrs: {
                                label:
                                  _vm.formThead[iii] &&
                                  _vm.formThead[iii].title,
                                "min-width": "160",
                                align: "center",
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        iii === "barCode"
                                          ? _c("el-input", {
                                              staticClass: "priceBox",
                                              attrs: {
                                                disabled: "",
                                                maxlength: "40",
                                                type: "test",
                                                readonly: false,
                                              },
                                              model: {
                                                value: scope.row[iii],
                                                callback: function ($$v) {
                                                  _vm.$set(scope.row, iii, $$v)
                                                },
                                                expression: "scope.row[iii]",
                                              },
                                            })
                                          : _c("el-input-number", {
                                              attrs: {
                                                disabled:
                                                  _vm.isDisabled ||
                                                  iii === "cost",
                                                min: 0,
                                                max:
                                                  iii === "stock" ||
                                                  iii === "redeemIntegral"
                                                    ? 999999
                                                    : 999999.99,
                                                step:
                                                  iii === "stock" ||
                                                  iii === "redeemIntegral"
                                                    ? 1
                                                    : 0.01,
                                                "controls-position": "right",
                                                "step-strictly": "",
                                              },
                                              model: {
                                                value: scope.row[iii],
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    scope.row,
                                                    iii,
                                                    typeof $$v === "string"
                                                      ? $$v.trim()
                                                      : $$v
                                                  )
                                                },
                                                expression: "scope.row[iii]",
                                              },
                                            }),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            })
                          }),
                        ],
                        2
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.formValidate.specType
                ? _c(
                    "el-form-item",
                    {
                      staticClass: "labeltop",
                      class: _vm.isDisabled ? "disLabel" : "disLabelmoren",
                      attrs: { label: "商品属性：" },
                    },
                    [
                      _c("el-alert", {
                        attrs: {
                          title: "价格设置范围 0.01~999999.99",
                          type: "info",
                        },
                      }),
                      _c(
                        "el-table",
                        {
                          key: _vm.tableKey,
                          staticClass: "tabNumWidth",
                          attrs: {
                            data: _vm.ManyAttrValue,
                            border: "",
                            size: "small",
                            "span-method": _vm.objectSpanMethod,
                            "cell-class-name": _vm.tableCellClassName,
                          },
                        },
                        _vm._l(_vm.formValidate.header, function (item, index) {
                          return _c("el-table-column", {
                            key: index,
                            attrs: {
                              label: item.title,
                              "min-width": item.minWidth || "100",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      scope.$index == 0
                                        ? [
                                            item.key
                                              ? [
                                                  _vm.formValidate.attrs[
                                                    scope.column.index
                                                  ] && _vm.ManyAttrValue.length
                                                    ? _c(
                                                        "div",
                                                        [
                                                          _c(
                                                            "el-select",
                                                            {
                                                              attrs: {
                                                                placeholder:
                                                                  "请选择" +
                                                                  item.title,
                                                                clearable: "",
                                                              },
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .oneFormBatch[0][
                                                                    item.title
                                                                  ],
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm
                                                                        .oneFormBatch[0],
                                                                      item.title,
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "oneFormBatch[0][item.title]",
                                                              },
                                                            },
                                                            _vm._l(
                                                              _vm.formValidate
                                                                .attrs[
                                                                scope.column
                                                                  .index
                                                              ].detail,
                                                              function (val) {
                                                                return _c(
                                                                  "el-option",
                                                                  {
                                                                    key: val.value,
                                                                    attrs: {
                                                                      label:
                                                                        val.value,
                                                                      value:
                                                                        val.value,
                                                                    },
                                                                  }
                                                                )
                                                              }
                                                            ),
                                                            1
                                                          ),
                                                        ],
                                                        1
                                                      )
                                                    : _vm._e(),
                                                ]
                                              : item.slot === "image"
                                              ? [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "upLoadPicBox specPictrue",
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.modalPicTap(
                                                            false,
                                                            "pi",
                                                            scope.$index
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _vm.oneFormBatch[0].image
                                                        ? _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "upLoad tabPic",
                                                            },
                                                            [
                                                              _c("img", {
                                                                directives: [
                                                                  {
                                                                    name: "lazy",
                                                                    rawName:
                                                                      "v-lazy",
                                                                    value:
                                                                      _vm
                                                                        .oneFormBatch[0]
                                                                        .image,
                                                                    expression:
                                                                      "oneFormBatch[0].image",
                                                                  },
                                                                ],
                                                              }),
                                                            ]
                                                          )
                                                        : _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "upLoad tabPic",
                                                            },
                                                            [
                                                              _c("i", {
                                                                staticClass:
                                                                  "el-icon-camera cameraIconfont",
                                                              }),
                                                            ]
                                                          ),
                                                    ]
                                                  ),
                                                ]
                                              : item.slot === "price"
                                              ? [
                                                  _c("el-input-number", {
                                                    staticClass: "priceBox",
                                                    attrs: {
                                                      controls: false,
                                                      min: 0,
                                                      max: 999999.99,
                                                      "controls-position":
                                                        "right",
                                                      clearable: "",
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.oneFormBatch[0]
                                                          .price,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.oneFormBatch[0],
                                                          "price",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "oneFormBatch[0].price",
                                                    },
                                                  }),
                                                ]
                                              : item.slot === "redeemIntegral"
                                              ? [
                                                  _c("el-input-number", {
                                                    staticClass: "priceBox",
                                                    attrs: {
                                                      controls: false,
                                                      min: 0,
                                                      max: 999999,
                                                      "controls-position":
                                                        "right",
                                                      clearable: "",
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.oneFormBatch[0]
                                                          .redeemIntegral,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.oneFormBatch[0],
                                                          "redeemIntegral",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "oneFormBatch[0].redeemIntegral",
                                                    },
                                                  }),
                                                ]
                                              : item.slot === "cost"
                                              ? [
                                                  _c("el-input-number", {
                                                    staticClass: "priceBox",
                                                    attrs: {
                                                      controls: false,
                                                      min: 0,
                                                      max: 999999.99,
                                                      "controls-position":
                                                        "right",
                                                      clearable: "",
                                                      disabled: "",
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.oneFormBatch[0]
                                                          .cost,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.oneFormBatch[0],
                                                          "cost",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "oneFormBatch[0].cost",
                                                    },
                                                  }),
                                                ]
                                              : item.slot === "otPrice"
                                              ? [
                                                  _c("el-input-number", {
                                                    staticClass: "priceBox",
                                                    attrs: {
                                                      controls: false,
                                                      min: 0,
                                                      max: 999999.99,
                                                      "controls-position":
                                                        "right",
                                                      clearable: "",
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.oneFormBatch[0]
                                                          .otPrice,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.oneFormBatch[0],
                                                          "otPrice",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "oneFormBatch[0].otPrice",
                                                    },
                                                  }),
                                                ]
                                              : item.slot === "stock"
                                              ? [
                                                  _c("el-input-number", {
                                                    staticClass: "priceBox",
                                                    attrs: {
                                                      controls: false,
                                                      disabled:
                                                        _vm.formValidate.type ==
                                                          3 ||
                                                        _vm.formValidate.type ==
                                                          2,
                                                      min: 0,
                                                      max: 999999,
                                                      "controls-position":
                                                        "right",
                                                      clearable: "",
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.oneFormBatch[0]
                                                          .stock,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.oneFormBatch[0],
                                                          "stock",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "oneFormBatch[0].stock",
                                                    },
                                                  }),
                                                ]
                                              : item.slot === "barCode"
                                              ? [
                                                  _c("el-input", {
                                                    staticClass: "priceBox",
                                                    attrs: {
                                                      maxlength: "40",
                                                      disabled: "",
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.oneFormBatch[0]
                                                          .barCode,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.oneFormBatch[0],
                                                          "barCode",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "oneFormBatch[0].barCode",
                                                    },
                                                  }),
                                                ]
                                              : item.slot === "weight"
                                              ? [
                                                  _c("el-input-number", {
                                                    staticClass: "priceBox",
                                                    attrs: {
                                                      controls: false,
                                                      step: 0.1,
                                                      min: 0,
                                                      max: 999999,
                                                      clearable: "",
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.oneFormBatch[0]
                                                          .weight,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.oneFormBatch[0],
                                                          "weight",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "oneFormBatch[0].weight",
                                                    },
                                                  }),
                                                ]
                                              : item.slot === "volume"
                                              ? [
                                                  _c("el-input-number", {
                                                    staticClass: "priceBox",
                                                    attrs: {
                                                      controls: false,
                                                      step: 0.1,
                                                      min: 0,
                                                      max: 999999,
                                                      clearable: "",
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.oneFormBatch[0]
                                                          .volume,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.oneFormBatch[0],
                                                          "volume",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "oneFormBatch[0].volume",
                                                    },
                                                  }),
                                                ]
                                              : item.slot === "isDefault"
                                              ? [_vm._v(" -- ")]
                                              : item.slot === "action"
                                              ? [
                                                  _c(
                                                    "a",
                                                    {
                                                      attrs: {
                                                        type: "text",
                                                        size: "mini",
                                                      },
                                                      on: {
                                                        click: _vm.batchAdd,
                                                      },
                                                    },
                                                    [_vm._v("批量修改")]
                                                  ),
                                                  _c(
                                                    "a",
                                                    {
                                                      attrs: {
                                                        type: "text",
                                                        size: "mini",
                                                      },
                                                      on: {
                                                        click: _vm.batchDel,
                                                      },
                                                    },
                                                    [_vm._v("清空")]
                                                  ),
                                                ]
                                              : _vm._e(),
                                          ]
                                        : [
                                            item.key
                                              ? [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "text-center",
                                                    },
                                                    [
                                                      _c("span", [
                                                        _vm._v(
                                                          _vm._s(
                                                            scope.row
                                                              .attrValueShow[
                                                              item.key
                                                            ]
                                                          )
                                                        ),
                                                      ]),
                                                    ]
                                                  ),
                                                ]
                                              : _vm._e(),
                                            item.slot === "image"
                                              ? [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "upLoadPicBox specPictrue",
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.modalPicTap(
                                                            false,
                                                            "duo",
                                                            scope.$index
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      scope.row.image
                                                        ? _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "upLoad tabPic",
                                                            },
                                                            [
                                                              _c("img", {
                                                                attrs: {
                                                                  src: scope.row
                                                                    .image,
                                                                },
                                                              }),
                                                            ]
                                                          )
                                                        : _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "upLoad tabPic",
                                                            },
                                                            [
                                                              _c("i", {
                                                                staticClass:
                                                                  "el-icon-camera cameraIconfont",
                                                                staticStyle: {
                                                                  "font-size":
                                                                    "24px",
                                                                },
                                                              }),
                                                            ]
                                                          ),
                                                    ]
                                                  ),
                                                ]
                                              : item.slot === "price"
                                              ? [
                                                  _c("el-input-number", {
                                                    staticClass: "priceBox",
                                                    attrs: {
                                                      controls: false,
                                                      min: 0,
                                                      max: 999999.99,
                                                      "controls-position":
                                                        "right",
                                                      clearable: "",
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.ManyAttrValue[
                                                          scope.$index
                                                        ].price,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.ManyAttrValue[
                                                            scope.$index
                                                          ],
                                                          "price",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "ManyAttrValue[scope.$index].price",
                                                    },
                                                  }),
                                                ]
                                              : item.slot === "redeemIntegral"
                                              ? [
                                                  _c("el-input-number", {
                                                    staticClass: "priceBox",
                                                    attrs: {
                                                      controls: false,
                                                      min: 0,
                                                      max: 999999,
                                                      "controls-position":
                                                        "right",
                                                      clearable: "",
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.ManyAttrValue[
                                                          scope.$index
                                                        ].redeemIntegral,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.ManyAttrValue[
                                                            scope.$index
                                                          ],
                                                          "redeemIntegral",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "ManyAttrValue[scope.$index].redeemIntegral",
                                                    },
                                                  }),
                                                ]
                                              : item.slot === "cost"
                                              ? [
                                                  _c("el-input-number", {
                                                    staticClass: "priceBox",
                                                    attrs: {
                                                      controls: false,
                                                      min: 0,
                                                      max: 999999.99,
                                                      "controls-position":
                                                        "right",
                                                      clearable: "",
                                                      disabled: "",
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.ManyAttrValue[
                                                          scope.$index
                                                        ].cost,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.ManyAttrValue[
                                                            scope.$index
                                                          ],
                                                          "cost",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "ManyAttrValue[scope.$index].cost",
                                                    },
                                                  }),
                                                ]
                                              : item.slot === "otPrice"
                                              ? [
                                                  _c("el-input-number", {
                                                    staticClass: "priceBox",
                                                    attrs: {
                                                      controls: false,
                                                      min: 0,
                                                      max: 999999.99,
                                                      "controls-position":
                                                        "right",
                                                      clearable: "",
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.ManyAttrValue[
                                                          scope.$index
                                                        ].otPrice,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.ManyAttrValue[
                                                            scope.$index
                                                          ],
                                                          "otPrice",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "ManyAttrValue[scope.$index].otPrice",
                                                    },
                                                  }),
                                                ]
                                              : item.slot === "stock"
                                              ? [
                                                  _c("el-input-number", {
                                                    staticClass: "priceBox",
                                                    attrs: {
                                                      controls: false,
                                                      min: 0,
                                                      max: 999999,
                                                      "controls-position":
                                                        "right",
                                                      clearable: "",
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.ManyAttrValue[
                                                          scope.$index
                                                        ].stock,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.ManyAttrValue[
                                                            scope.$index
                                                          ],
                                                          "stock",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "ManyAttrValue[scope.$index].stock",
                                                    },
                                                  }),
                                                ]
                                              : item.slot === "barCode"
                                              ? [
                                                  _c("el-input", {
                                                    staticClass: "priceBox",
                                                    attrs: {
                                                      maxlength: "40",
                                                      disabled: "",
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.ManyAttrValue[
                                                          scope.$index
                                                        ].barCode,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.ManyAttrValue[
                                                            scope.$index
                                                          ],
                                                          "barCode",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "ManyAttrValue[scope.$index].barCode",
                                                    },
                                                  }),
                                                ]
                                              : item.slot === "weight"
                                              ? [
                                                  _c("el-input-number", {
                                                    staticClass: "priceBox",
                                                    attrs: {
                                                      controls: false,
                                                      step: 0.1,
                                                      min: 0,
                                                      max: 999999,
                                                      clearable: "",
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.ManyAttrValue[
                                                          scope.$index
                                                        ].weight,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.ManyAttrValue[
                                                            scope.$index
                                                          ],
                                                          "weight",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "ManyAttrValue[scope.$index].weight",
                                                    },
                                                  }),
                                                ]
                                              : item.slot === "volume"
                                              ? [
                                                  _c("el-input-number", {
                                                    staticClass: "priceBox",
                                                    attrs: {
                                                      controls: false,
                                                      step: 0.1,
                                                      min: 0,
                                                      max: 999999,
                                                      clearable: "",
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.ManyAttrValue[
                                                          scope.$index
                                                        ].volume,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.ManyAttrValue[
                                                            scope.$index
                                                          ],
                                                          "volume",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "ManyAttrValue[scope.$index].volume",
                                                    },
                                                  }),
                                                ]
                                              : item.slot === "isDefault"
                                              ? [
                                                  _c("el-switch", {
                                                    attrs: {
                                                      "active-text": "默认",
                                                    },
                                                    on: {
                                                      change: function (e) {
                                                        return _vm.changeDefaultSelect(
                                                          e,
                                                          scope.$index
                                                        )
                                                      },
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.ManyAttrValue[
                                                          scope.$index
                                                        ].isDefault,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.ManyAttrValue[
                                                            scope.$index
                                                          ],
                                                          "isDefault",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "ManyAttrValue[scope.$index].isDefault",
                                                    },
                                                  }),
                                                ]
                                              : item.slot === "action"
                                              ? [
                                                  _c("el-switch", {
                                                    staticClass: "defineSwitch",
                                                    attrs: {
                                                      "active-text": "显示",
                                                      "inactive-text": "隐藏",
                                                      "active-value": true,
                                                      "inactive-value": false,
                                                    },
                                                    on: {
                                                      change: function (
                                                        $event
                                                      ) {
                                                        return _vm.changeDefaultShow(
                                                          scope.$index
                                                        )
                                                      },
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.ManyAttrValue[
                                                          scope.$index
                                                        ].isShow,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.ManyAttrValue[
                                                            scope.$index
                                                          ],
                                                          "isShow",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "ManyAttrValue[scope.$index].isShow",
                                                    },
                                                  }),
                                                ]
                                              : _vm._e(),
                                          ],
                                    ]
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }